export const isEqualCurrency = (value = {}, other = {}) =>
  value.code === other.code;
